import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../models/base/base.component';
import { Router } from '@angular/router';
import { LookupService } from '../../services/lookup.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'quote-detail',
  templateUrl: './quote-detail.component.html',
  providers: [LookupService]
})
export class QuoteDetailComponent extends BaseComponent implements OnInit {
  @Input() model: any = null;
  @Input() showHeader: boolean = true;
  @Input() showVehicles: boolean = true;

  invoiceComplete: boolean = false;
  invoicePaid: boolean = false;
  loaded = false;

  isAdmin: boolean = false;
  lookups = {};
  metadata = {};

  @Input() showModal = true;

  constructor(
    private router: Router,
    private lookupService: LookupService,
    private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.loadLookup('yesNoPartial');
    this.loadLookup('phoneType');
    this.loadLookup('stateCode');
    this.loadLookup('openEnclosed');
    this.loadLookup('operability');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] != null && (changes['model'].firstChange || (changes['model'].currentValue != changes['model'].previousValue))) {
      if (this.model != null && !this.loaded) {
        this.metadata = this.model.metadata;
        this.loaded = true;
      }
    }
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  close() {
    this.navigationService.showDetail(false);
  }

}
